module.exports = __webpack_public_path__ + "media/images/icons/hamer-ad0d0b06da05230c87908b347ce29bf9.svg";